module.exports = __webpack_public_path__ + "img/123.aa58786b.png";